import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  Production_Proposal_ProposalName: {
    name: 'name',
    title: 'Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/proposal/{id}',
    openUrlInNewTab: false,
  },
  Line_ExternalCode: {
    name: 'line',
    title: 'Line',
    type: EnhancedTableHeaderType.Text,
  },
  subline_ExternalCode: {
    name: 'subline',
    title: 'Subline',
    type: EnhancedTableHeaderType.Text,
  },
  plan_ExternalCode: {
    name: 'plan',
    title: 'Plan',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Insured_FullName: {
    name: 'insured',
    title: 'Insured',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Proposal_PolicyEffectiveDate: {
    name: 'effectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date,
  },
  Production_Proposal_Status: {
    name: 'status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Proposal_StatusReason: {
    name: 'statusReason',
    title: 'Status Reason',
    type: EnhancedTableHeaderType.Text,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        line: {
          name: 'line',
          title: 'Line',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.line || [],
          placeholder: 'Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line },
        },
        subline: {
          name: 'subline',
          title: 'Subline',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.subline || [],
          placeholder: 'Subline',
          triggerUpdate: true,
          selectOptions: { ...lovs.subline },
        },
        plan: {
          name: 'plan',
          title: 'Plan',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.plan || [],
          placeholder: 'Plan',
          triggerUpdate: true,
          selectOptions: { ...lovs.plan },
        },
        businessPartner: {
          name: 'businessPartner',
          title: 'Business Partner',
          type: FormInputTypes.newmultiautocomplete,
          value: filterValues?.businessPartner || [],
          placeholder: 'Business Partner',
          triggerUpdate: true,
        },
        insured: {
          name: 'insured',
          title: 'Insured',
          type: FormInputTypes.newmultiautocomplete,
          value: filterValues?.insured || [],
          placeholder: 'Insured',
          triggerUpdate: true,
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status },
        },
        statusReason: {
          name: 'statusReason',
          title: 'Status Reason',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.statusReason || [],
          placeholder: 'Status Reason',
          triggerUpdate: true,
          selectOptions: { ...lovs.statusReason },
        },
        effectiveOn: {
          name: 'effectiveOn',
          title: 'Effective Date',
          type: FormInputTypes.newdaterange,
          value: filterValues?.effectiveOn || [],
          placeholder: 'Effective Date',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
